import React, { useState } from 'react';
import { View, Text, StyleSheet, TextInput, TouchableOpacity, Platform, Linking } from 'react-native';
import { colores, fuentes } from '../../styles/variablesCss';

const ArrepentimientoDeCompra = () => {
  const [nombre, setNombre] = useState('');
  const [contacto, setContacto] = useState('');
  const [pedido, setPedido] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');

  const handleEnviar = async () => {
    setError('');
    if (!nombre.trim() || !contacto.trim() || !pedido.trim()) {
      setError('Por favor, completá todos los campos.');
      return;
    }
    setEnviando(true);

    // 1) Enviar email de constancia al usuario (mailto por ahora)
    try {
      const mail = encodeURIComponent(contacto);
      const subject = encodeURIComponent('Confirmación de arrepentimiento de compra');
      const body = encodeURIComponent(
        `Hola ${nombre},%0D%0A%0D%0ARecibimos tu solicitud de arrepentimiento de compra.%0D%0ANúmero de pedido/comprobante: ${pedido}.%0D%0A%0D%0AProcederemos a dar de baja el pedido y a gestionar la devolución. Verás la acreditación en unas horas.%0D%0A%0D%0AGracias.%0D%0AEquipo de Supermercados Pingüino`
      );
      const mailtoUrl = `mailto:${mail}?subject=${subject}&body=${body}`;

      if (Platform.OS === 'web') {
        window.open(mailtoUrl, '_blank');
      } else {
        await Linking.openURL(mailtoUrl);
      }
    } catch (e) {
      // seguir igualmente, la constancia se muestra en pantalla
      
    }

    // 2) Placeholder para futura integración backend: baja del pedido y aviso al área
    // TODO: implementar POST a /api/arrepentimiento (cuando exista backend)
    // await fetch('/api/arrepentimiento', { method: 'POST', body: JSON.stringify({ nombre, contacto, pedido }) })

    setEnviado(true);
    setEnviando(false);
  };

  if (enviado) {
    return (
      <View style={styles.wrapper}>
        <View style={styles.card}>
          <Text style={styles.title}>Constancia de recepción</Text>
          <Text style={styles.okText}>Recibimos tu solicitud de arrepentimiento de compra.</Text>
          <Text style={styles.okText}>Pedido/Comprobante: <Text style={styles.bold}>{pedido}</Text></Text>
          <Text style={styles.okText}>Te enviamos un email confirmando la baja del pedido.</Text>
          <Text style={styles.okText}>El dinero se devolverá y acreditará en unas horas.</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.wrapper}>
      <View style={styles.card}>
        <Text style={styles.title}>Arrepentimiento de compra</Text>
        <View style={styles.formGroup}>
          <Text style={styles.label}>Nombre y apellido</Text>
          <TextInput
            style={styles.input}
            value={nombre}
            onChangeText={setNombre}
            placeholder="Tu nombre y apellido"
            placeholderTextColor="#9aa0a6"
          />
        </View>
        <View style={styles.formGroup}>
          <Text style={styles.label}>Email o teléfono de contacto</Text>
          <TextInput
            style={styles.input}
            value={contacto}
            onChangeText={setContacto}
            placeholder="email@dominio.com o +54 9 ..."
            keyboardType="email-address"
            placeholderTextColor="#9aa0a6"
          />
        </View>
        <View style={styles.formGroup}>
          <Text style={styles.label}>Número de pedido o comprobante de compra</Text>
          <TextInput
            style={styles.input}
            value={pedido}
            onChangeText={setPedido}
            placeholder="Ej: #A12345 / 0001-00001234"
            placeholderTextColor="#9aa0a6"
          />
        </View>
        {error ? <Text style={styles.error}>{error}</Text> : null}
        <TouchableOpacity style={styles.button} onPress={handleEnviar} disabled={enviando}>
          <Text style={styles.buttonText}>{enviando ? 'Enviando...' : 'Enviar solicitud'}</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 24,
    alignItems: 'center',
  },
  card: {
    width: '100%',
    maxWidth: 720,
    backgroundColor: colores.blanco,
    borderRadius: 8,
    padding: 16,
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }
      : { elevation: 2 }),
  },
  title: {
    fontFamily: fuentes.bold,
    fontSize: 20,
    color: colores.texto,
    marginBottom: 12,
  },
  formGroup: {
    marginBottom: 12,
  },
  label: {
    fontFamily: fuentes.semiBold,
    fontSize: 14,
    color: colores.texto,
    marginBottom: 6,
  },
  input: {
    borderWidth: 1,
    borderColor: '#d0d7de',
    borderRadius: 6,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 14,
    color: colores.texto,
    backgroundColor: '#fff',
  },
  button: {
    marginTop: 8,
    backgroundColor: colores.rojo,
    paddingVertical: 12,
    borderRadius: 6,
    alignItems: 'center',
  },
  buttonText: {
    color: '#fff',
    fontFamily: fuentes.bold,
    fontSize: 16,
  },
  error: {
    color: '#b00020',
    marginBottom: 8,
  },
  okText: {
    color: colores.texto,
    fontSize: 14,
    marginBottom: 6,
  },
  bold: {
    fontFamily: fuentes.bold,
  },
});

export default ArrepentimientoDeCompra;
